@if (isAuthenticated()) {
  <div class="report-widget">
    @if (isOpen()) {
      <div class="report-widget__menu" role="menu" aria-label="Report">
        <button
          type="button"
          class="report-widget__item"
          role="menuitem"
          (click)="openReport('BUG')"
        >
          <app-icon name="bug" [size]="16" />
          <span>
            Report a bug
            <small>Something isn't working</small>
          </span>
        </button>
        <button
          type="button"
          class="report-widget__item"
          role="menuitem"
          (click)="openReport('SUGGESTION')"
        >
          <app-icon name="lightbulb" [size]="16" />
          <span>
            Make a suggestion
            <small>An idea to improve Flow</small>
          </span>
        </button>
      </div>
    }

    <button
      type="button"
      class="report-widget__trigger"
      [class.report-widget__trigger--open]="isOpen()"
      [attr.aria-expanded]="isOpen()"
      aria-haspopup="menu"
      aria-label="Report a suggestion or bug"
      matTooltip="Report a suggestion or bug"
      matTooltipPosition="left"
      (click)="toggle()"
    >
      <app-icon [name]="isOpen() ? 'x' : 'grip'" [size]="20" />
    </button>
  </div>
}
